import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  ShieldCheck,
  FileText,
  CheckSquare,
  Activity,
  LogOut,
  Menu,
  X,
  CheckCircle
} from 'lucide-react';

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  const navItems = [
    { name: 'Dashboard', path: '/admin/dashboard', icon: LayoutDashboard },
    { name: 'Bewerbungen', path: '/admin/applications', icon: Users },
    { name: 'Identitätsprüfungen', path: '/admin/verifications', icon: ShieldCheck },
    { name: 'Test-Sessions', path: '/admin/test-sessions', icon: Activity },
    { name: 'Aufgaben', path: '/admin/tasks', icon: CheckSquare },
    { name: 'Dokumente', path: '/admin/dokumente', icon: FileText },
    { name: 'Report-Prüfungen', path: '/admin/reports', icon: CheckCircle },
  ];

  return (
    <div className="min-h-screen bg-background flex">
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-primary text-slate-300 flex flex-col shadow-xl transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0 ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="h-16 flex items-center justify-between px-6 border-b border-secondary/50">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-white tracking-tight">
              ENVISU<span className="text-accent">.</span>
            </span>
            <span className="ml-2 text-xs bg-accent text-primary px-2 py-0.5 rounded-full font-bold">
              ADMIN
            </span>
          </div>
          <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(false)}>
            <X className="w-6 h-6" />
          </button>
        </div>
        <nav className="flex-1 py-6 px-3 space-y-1 overflow-y-auto">
          {navItems.map((item) => {
            const isActive = location.pathname.includes(item.path);
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors ${
                  isActive
                    ? 'bg-accent/10 text-accent font-medium'
                    : 'hover:bg-secondary/50 hover:text-white'
                }`}
              >
                <Icon className={`w-5 h-5 ${isActive ? 'text-accent' : 'text-slate-400'}`} />
                {item.name}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-secondary/50">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-3 py-2.5 w-full rounded-md text-slate-400 hover:bg-secondary/50 hover:text-white transition-colors"
          >
            <LogOut className="w-5 h-5" />
            Abmelden
          </button>
        </div>
      </aside>
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <header className="h-16 bg-white border-b border-border flex items-center justify-between px-4 sm:px-8 shadow-sm z-10 shrink-0">
          <div className="flex items-center gap-3">
            <button
              className="md:hidden p-2 -ml-2 text-primary hover:bg-slate-100 rounded-md"
              onClick={() => setIsMobileMenuOpen(true)}
            >
              <Menu className="w-6 h-6" />
            </button>
            <h2 className="text-xl font-semibold text-primary truncate">
              {navItems.find(item => location.pathname.includes(item.path))?.name || 'Admin Bereich'}
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center text-white font-bold shrink-0">
              E
            </div>
          </div>
        </header>
        <div className="flex-1 overflow-auto p-4 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}